/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react'
import { Form, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { NannyEditprofile, clearData } from '../../store/apiSlice/NeditProfileSlice';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import { uploadFile } from '../../store/apiSlice/uploadFileSlice';
import profile_icon from '../../assets/img/profile_icon.png';
import { getNannyProfile } from '../../store/apiSlice/NannyprofileSlice';
import Select from 'react-select';
import { ClipLoader } from 'react-spinners';
import { capitalizeFirstLetter } from '../../utils/help';
import PlaceSearch from "../map/Googlemap";
import { requestPhoneChange, verifyPhoneChange, clearChangePhone } from '../../store/apiSlice/ChangePhoneSlice';

const NeditProfile = () => {
    const dispatch = useDispatch();
    const NannyEditData = useSelector((state) => state.rootReducer.NannyEditprofileReducer.data);
    const profileData = useSelector((state) => state.rootReducer.nannyProfileReducer.data);
    const uploadFileData = useSelector((state) => state.rootReducer.uploadFileReducer.data);
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [date, setDate] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [education, setEducation] = useState('');
    const [country, setCountry] = useState('');
    const [profileImage, setProfileImage] = useState('');
    const [description, setDescription] = useState('');
    const [experienceOfYears, setExperienceOfYears] = useState('');
    const [familyBackground, setFamilyBackground] = useState('');
    const [isCarOwn, setIsCarOwn] = useState(1);
    const [isGoodWithDogSitting, setIsGoodWithDogSitting] = useState(1);
    const [isDrivingLicense, setIsDrivingLicense] = useState(1);
    const [isSmoker, setIsSmoker] = useState(1);
    const [isCleaningUp, setIsCleaningUp] = useState(1);
    const [disabled, setDisabled] = useState(false)
    const [languages, setLanguages] = useState([]);
    const [mostExperienceAge, setMostExperienceAge] = useState(null);
    const [skills, setSkills] = useState([]);
    const [loading, setLoading] = useState(false)
    const [address, setAddress] = useState('');
    const [teachingExperience, setTeachingExperience] = useState(1);
    const [newBornExperience, setNewBornExperience] = useState(1);
    const [childcareExperience, setChildcareExperience] = useState('');
    const textareaRef = useRef(null);
    const childcareExperienceRef = useRef(null);

    const [coverLetter, setCoverLetter] = useState(null);
    const [cv, setCv] = useState(null);
    const [idProof, setIdProof] = useState(null);
    const [uploadFileFor, setUploadFileFor] = useState(null);


    const [showMap, setShowMap] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [editedApt, setEditedApt] = useState('');
    const [editedHouse, setEditedHouse] = useState('');
    const [editedStreet, setEditedStreet] = useState('');

    // Change phone number state
    const changePhoneData = useSelector((state) => state.rootReducer.changePhone);
    const [showPhoneChange, setShowPhoneChange] = useState(false);
    const [newPhone, setNewPhone] = useState('');
    const [newPhoneCountry, setNewPhoneCountry] = useState('34');
    const [phoneOtp, setPhoneOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [phoneUserId, setPhoneUserId] = useState(null);

    const handlePdfUpload = (event, type) => {
        setUploadFileFor(type)
        const file = event.target.files[0];
        if (!file) {
            alert('Please select a file');
            return;
        }

        if (file.type !== 'application/pdf') {
            alert('Only PDF files are allowed');
            return;
        }

        setLoading(true);
        dispatch(uploadFile(file)).then((res) => {
            if (res?.payload?.Location) {
                if (type === 'coverLetter') setCoverLetter(res.payload.Location);
                if (type === 'cv') setCv(res.payload.Location);
                if (type === 'idProof') setIdProof(res.payload.Location);
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        if (!showMap) return;

        if (!navigator.geolocation) {
            setError("Geolocation not supported");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
                setLatitude(coords.latitude);
                setLongitude(coords.longitude);
                setError(null);
            },
            (err) => {
                setError(err.message);
                setLatitude(null);
                setLongitude(null);
            }
        );
    }, [showMap]);

    useEffect(() => {
        if (childcareExperienceRef.current) {
            childcareExperienceRef.current.style.height = 'auto';
            childcareExperienceRef.current.style.height = `${childcareExperienceRef.current.scrollHeight}px`;
        }
    }, [childcareExperience]);

    const updateProfile = () => {
        if (disabled) {
            const payload = {
                firstName,
                lastName,
                dateOfBirth: date,
                address,
                profileImage,
                pinCode,
                latitude: latitude ?? profileData?.data?.latitude,
                longitude: longitude ?? profileData?.data?.longitude,
                countryCode: profileData?.data?.countryCode,
                description,
                experienceOfYears,
                familyBackground,
                isCarOwn,
                isDrivingLicense,
                isGoodWithDogSitting,
                isSmoker,
                isCleaningUp,
                education,
                languages: languages.map(elm => elm.value).join(', '),
                childcareExperience,
                mostExperienceAge: mostExperienceAge ? mostExperienceAge.value : '',
                skills: skills.map(elm => elm.value),
                teachingExperience,
                newBornExperience,
                coverLetter,
                cv,
                idProof
            };
            const requiredFields = {
                "First Name": payload.firstName,
                "Last Name": payload.lastName,
                "Date of Birth": payload.dateOfBirth,
                "Address": payload.address,
                "Profile Image": payload.profileImage,
                "Postal Code": payload.pinCode,
                "Latitude": payload.latitude,
                "Longitude": payload.longitude,
                "Country Code": payload.countryCode,
                "About": payload.description,
                "Experience (Years)": payload.experienceOfYears,
                "Family Background": payload.familyBackground,
                "Car Ownership": payload.isCarOwn,
                "Driving License": payload.isDrivingLicense,
                "Dog Sitting Skill": payload.isGoodWithDogSitting,
                "Smoker Status": payload.isSmoker,
                "Cleaning Up": payload.isCleaningUp,
                "Education": payload.education,
                "Languages": payload.languages,
                "Childcare Experience": payload.childcareExperience,
                "Most Experienced Age": payload.mostExperienceAge,
                "Skills": payload.skills,
                "Teaching Experience": payload.teachingExperience,
                "Newborn Experience": payload.newBornExperience,
                "Cover Letter": payload.coverLetter,
                "CV": payload.cv,
                "ID Proof": payload.idProof
            };

            for (const [fieldName, value] of Object.entries(requiredFields)) {
                if (
                    value === undefined ||
                    value === null ||
                    (typeof value === "string" && value.trim() === "") ||
                    (Array.isArray(value) && value.length === 0)
                ) {
                    alert(`Please fill in the "${fieldName}" field.`);
                    return;
                }
            }

            try {
                setLoading(true);
                dispatch(NannyEditprofile(payload));
            } catch (error) {
                setLoading(false);
                alert("Something went wrong while updating your profile. Please try again.");
            }
        } else {
            setDisabled(true);
        }
    };


    useEffect(() => {
        if (NannyEditData != null && NannyEditData.status === 1) {
            setDisabled(false);
            dispatch(getNannyProfile());
            dispatch(clearData())
            setLoading(false)
            alert(NannyEditData.message);
        }
        else if (NannyEditData != null) {
            alert(NannyEditData.message)
            setLoading(false)
        }
    }, [NannyEditData])


    useEffect(() => {
        if (profileData != null && profileData.status === 1) {
            setFirstName(profileData.data.firstName ? capitalizeFirstLetter(profileData.data.firstName) : '');
            setLastName(profileData.data.lastName ? capitalizeFirstLetter(profileData.data.lastName) : '');
            setDate(profileData.data.dateOfBirth || '');
            setEmail(profileData.data.email || '');
            setAddress(profileData.data.address || '');
            setEducation(profileData.data.education || '');
            setPinCode(profileData.data.pinCode || '');
            setCountry(profileData.data.countryCode || '');
            setMobileNumber(profileData.data.mobileNumber || '');
            setProfileImage(profileData.data.profileImage || '');
            setDescription(profileData.data.description || '');
            setExperienceOfYears(profileData.data.experienceOfYears || '');
            setFamilyBackground(profileData.data.familyBackground ? capitalizeFirstLetter(profileData.data.familyBackground) : '');
            setIsCarOwn(profileData.data.isCarOwn || 0);
            setIsGoodWithDogSitting(profileData.data.isGoodWithDogSitting || 0);
            setIsDrivingLicense(profileData.data.isDrivingLicense || 0);
            setIsSmoker(profileData.data.isSmoker || 0);
            setIsCleaningUp(profileData.data.isCleaningUp || 0);

            if (profileData.data.languages) {
                const langsArray = profileData.data.languages.split(',').map(lang => ({ value: lang.trim(), label: lang.trim() }));
                setLanguages(langsArray);
            }

            setChildcareExperience(profileData.data.childcareExperience || '');
            setMostExperienceAge(profileData.data.mostExperienceAge ? { value: profileData.data.mostExperienceAge, label: profileData.data.mostExperienceAge } : null);
            setSkills(profileData.data.skills ? profileData.data.skills.map(skill => ({ value: skill, label: skill })) : []);
            setTeachingExperience(profileData.data.teachingExperience || 0);
            setNewBornExperience(profileData.data.newBornExperience || 0);

            setCoverLetter(profileData.data.coverLetter || null);
            setCv(profileData.data.cv || null);
            setIdProof(profileData.data.idProof || null);
        }

    }, [profileData])

    const handleOnChange = (value, country) => {
        setCountry(country.dialCode);
    };

    useEffect(() => {
        if (uploadFileData != null && uploadFileFor === 'profile_image') {
            setProfileImage(uploadFileData.Location);
            setLoading(false)
        }
    }, [uploadFileData]);

    const handleFileUpload = (event) => {
        setUploadFileFor('profile_image')
        const file = event.target.files[0];
        if (!file) {
            alert('Please select a file')
            return
        }
        setLoading(true)
        dispatch(uploadFile(file));
    };

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [description]);


    const options = [
        { value: 'English', label: 'English' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Chinese', label: 'Chinese' },
        { value: 'Arabic', label: 'Arabic' },
        { value: 'Portuguese', label: 'Portuguese' },
        { value: 'Russian', label: 'Russian' },
        { value: 'Japanese', label: 'Japanese' },
        { value: 'Korean', label: 'Korean' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Dutch', label: 'Dutch' },
        { value: 'Polish', label: 'Polish' },
        { value: 'Swedish', label: 'Swedish' },
        { value: 'Turkish', label: 'Turkish' },
        { value: 'Indonesian', label: 'Indonesian' },
        { value: 'Thai', label: 'Thai' },
        { value: 'Vietnamese', label: 'Vietnamese' },
        { value: 'Hebrew', label: 'Hebrew' }
    ];
    const mostExperienceAgeOptions = [
        { value: '0-4 years', label: '0-4 years' },
        { value: '0-8 years', label: '0-8 years' },
        { value: '0-12 years', label: '0-12 years' },
        { value: '4-8 years', label: '4-8 years' },
        { value: '8-12 years', label: '8-12 years' },
    ];

    const nannySkillsOptions = [
        { value: 'Certified and trained', label: 'Certified and trained' },
        { value: 'Experienced with all age groups', label: 'Experienced with all age groups' },
        { value: 'Reliable and punctual', label: 'Reliable and punctual' },
        { value: 'Excellent communication skills', label: 'Excellent communication skills' },
        { value: 'Discreet and trustworthy', label: 'Discreet and trustworthy' },
        { value: 'Engages children in educational play', label: 'Engages children in educational play' },
        { value: 'Emotionally intelligent', label: 'Emotionally intelligent' },
        { value: 'Encourages healthy routines', label: 'Encourages healthy routines' },
        { value: 'Supports child development', label: 'Supports child development' },
        { value: 'Handles challenges calmly', label: 'Handles challenges calmly' },
        { value: 'Warm and nurturing personality', label: 'Warm and nurturing personality' },
        { value: 'Pet friendly', label: 'Pet friendly' },
        { value: 'Active and energetic', label: 'Active and energetic' },
        { value: 'Flexible and adaptable', label: 'Flexible and adaptable' },
        { value: 'Positive and proactive', label: 'Positive and proactive' },
        { value: 'Multilingual or fluent in English', label: 'Multilingual or fluent in English' },
        { value: 'Light household support', label: 'Light household support' },
        { value: 'Travel ready', label: 'Travel ready' },
        { value: 'First aid trained', label: 'First aid trained' },
        { value: 'Representable and well-groomed', label: 'Representable and well-groomed' },
    ];

    const handleSelectChange = (selected) => setLanguages(selected || []);
    const handleMostExperienceAgeChange = (selected) => setMostExperienceAge(selected || null);
    const handleSkillsChange = (selected) => setSkills(selected || []);

    const handleSendPhoneOtp = () => {
        if (!newPhone || newPhone.trim() === '') {
            alert('Please enter a new phone number');
            return;
        }
        dispatch(requestPhoneChange({ newMobileNumber: newPhone, newCountryCode: `+${newPhoneCountry}` }));
    };

    const handleVerifyPhoneOtp = () => {
        if (!phoneOtp || phoneOtp.trim() === '') {
            alert('Please enter the OTP');
            return;
        }
        dispatch(verifyPhoneChange({ _id: phoneUserId, otp: phoneOtp, emailVerify: 3 }));
    };

    useEffect(() => {
        if (changePhoneData.requestData) {
            if (changePhoneData.requestData.status === 1) {
                setOtpSent(true);
                alert('OTP sent to your new phone number. Please enter it below.');
            } else {
                alert(changePhoneData.requestData.message || 'Failed to send OTP');
            }
            dispatch(clearChangePhone());
        }
    }, [changePhoneData.requestData]);

    useEffect(() => {
        if (changePhoneData.verifyData) {
            if (changePhoneData.verifyData.status === 1) {
                alert('Phone number updated successfully!');
                setShowPhoneChange(false);
                setOtpSent(false);
                setNewPhone('');
                setPhoneOtp('');
                dispatch(getNannyProfile());
            } else {
                alert(changePhoneData.verifyData.message || 'OTP verification failed');
            }
            dispatch(clearChangePhone());
        }
    }, [changePhoneData.verifyData]);

    useEffect(() => {
        if (profileData?.data?._id) {
            setPhoneUserId(profileData.data._id);
        }
    }, [profileData]);
    return (
        <>
            <div className="row" >
                <div className="col-12">
                    {profileData != null &&
                        <div className="row">
                            <div className="col-12 mb-4 edit_photo">
                                <div className='edit_flex'>
                                    <div className="upload-input upload_input_text">
                                        <label htmlFor="upload">
                                            <span>
                                                <img src={profileData != null && profileImage != "" ? profileImage : profile_icon} alt="card" />
                                            </span>
                                            <span>
                                                {disabled ? <input type="file" id="upload" style={{ display: "none" }} onChange={handleFileUpload} /> : null}
                                            </span>
                                        </label>
                                        <label className="btn_upload ms-3" style={{ color: "#89d6ce" }} htmlFor="upload">
                                            {disabled ? "Change Porfile Image" : ""}
                                        </label>
                                    </div>
                                    <button type='button' color="primary" className="profile_button save" onClick={() => updateProfile()}>
                                        {disabled
                                            ? (loading ? <ClipLoader size={16} color="#fff" /> : 'SAVE')
                                            : 'Edit Profile'}
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>First Name</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="text" disabled={!disabled} placeholder="First Name" value={firstName} onChange={(val) => setFirstName(val.target.value)} />
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Last Name</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="text" disabled={!disabled} placeholder="Last Name" value={lastName} onChange={(val) => setLastName(val.target.value)} />
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form>
                                    <div className='main_input'>
                                        <div className="input_field_flex ">
                                            <Form.Label>Phone Number</Form.Label>
                                            <div className='btn_flex'>
                                                <PhoneInput
                                                    disabled={true}
                                                    inputClass={"inputt-ph"}
                                                    containerStyle={{}}
                                                    searchClass="search-class"
                                                    disableSearchIcon={false}
                                                    enableTerritories
                                                    countryCodeEditable={false}
                                                    placeholder='Phone Number'
                                                    buttonStyle={{ width: '47px' }}
                                                    dropdownStyle={{ height: '150px' }}
                                                    enableSearch={true}
                                                    value={country}
                                                    onChange={handleOnChange}
                                                    readOnly
                                                />
                                                <input type='number' disabled={true} className='mobilenumber' value={mobileNumber} onChange={(val) => setMobileNumber(val.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Email</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="text" disabled={true} placeholder="Enter Email" value={email} onChange={(val) => setEmail(val.target.value)} />
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Postal Code</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="text" disabled={!disabled} placeholder="Postal Code" value={pinCode} onChange={(val) => setPinCode(val.target.value)} />
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Address</Form.Label>
                                    <div className="input-group mb-0">
                                        {/* <input type="text" disabled={!disabled} placeholder="Address" value={address} onChange={(val) => setAddress(val.target.value)} /> */}
                                        <input
                                            type="text"
                                            disabled={!disabled}
                                            placeholder="Address"
                                            value={address}
                                            readOnly
                                            onClick={() => setShowMap(true)}
                                            style={{ cursor: "pointer", backgroundColor: "#fdfdfd" }}
                                        />
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Date of Birth</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type='date' disabled={!disabled} value={date} onChange={(val) => setDate(val.target.value)} />
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Education</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="text" disabled={!disabled} placeholder="Education" value={education} onChange={(val) => setEducation(val.target.value)} />
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Family Background</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="text" disabled={!disabled} placeholder="Family Background" value={familyBackground} onChange={(val) => setFamilyBackground(val.target.value)} />
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Number of Years Experience</Form.Label>
                                    <div className="input-group mb-0">
                                        <input type="number" disabled={!disabled} value={experienceOfYears} placeholder="Number of Years Experience" />
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-12">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Language</Form.Label>
                                    <Select
                                        isMulti
                                        isDisabled={!disabled}
                                        options={options}
                                        value={languages}
                                        onChange={handleSelectChange}
                                    />
                                </form>
                            </div>

                            <div className="col-md-6">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>In what age group do you have the most experience</Form.Label>
                                    <Select
                                        isDisabled={!disabled}
                                        options={mostExperienceAgeOptions}
                                        value={mostExperienceAge}
                                        onChange={handleMostExperienceAgeChange}
                                    />
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you have new born baby experience?</Form.Label>
                                    <div >
                                        <Form.Select disabled={!disabled} aria-label="Default select example" value={newBornExperience} onChange={(e) => setNewBornExperience(e.target.value)}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-12">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Skills</Form.Label>
                                    <Select
                                        isMulti
                                        isDisabled={!disabled}
                                        options={nannySkillsOptions}
                                        value={skills}
                                        onChange={handleSkillsChange}
                                    />
                                </form>
                            </div>

                            <div className="col-md-12">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Childcare Expertise</Form.Label>
                                    <Form.Control
                                        placeholder='Describe your experience working with children'
                                        as="textarea"
                                        rows={3}
                                        disabled={!disabled}
                                        value={childcareExperience}
                                        onChange={(e) => setChildcareExperience(e.target.value)}
                                    />
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you have dog sitting experience?</Form.Label>
                                    <div className="input-group mb-0">
                                        <Form.Select disabled={!disabled} aria-label="Default select example" value={isGoodWithDogSitting} onChange={(e) => setIsGoodWithDogSitting(e.target.value)}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you smoke</Form.Label>
                                    <div className="input-group mb-0">
                                        <Form.Select disabled={!disabled} aria-label="Default select example" value={isSmoker} onChange={(e) => setIsSmoker(e.target.value)}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you have a drivers license</Form.Label>
                                    <div className="input-group mb-0">
                                        <Form.Select disabled={!disabled} aria-label="Default select example" value={isDrivingLicense} onChange={(e) => setIsDrivingLicense(e.target.value)}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you own a car</Form.Label>
                                    <div className="input-group mb-0">
                                        <Form.Select onChange={(e) => setIsCarOwn(e.target.value)} disabled={!disabled} aria-label="Default select example" value={isCarOwn}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you mind cleaning up after the child or do light housekeeping?</Form.Label>
                                    <div className="input-group mb-0">
                                        <Form.Select disabled={!disabled} aria-label="Default select example" value={isCleaningUp} onChange={(e) => setIsCleaningUp(e.target.value)}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>
                            <div className='col-md-6'>
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Do you have teaching experience</Form.Label>
                                    <div className="input-group mb-0">
                                        <Form.Select disabled={!disabled} aria-label="Default select example" value={teachingExperience} onChange={(e) => setTeachingExperience(e.target.value)}>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-12">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>About</Form.Label>
                                    <Form.Control
                                        placeholder='Please write at least five sentences about who you are and your experience working with children. Feel free to share as much as you like — parents truly enjoy getting to know more about you!'
                                        as="textarea"
                                        rows={3}
                                        disabled={!disabled}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </form>
                            </div>


                            {/* ── Change Phone Number ── */}
                            <div className="col-12 mt-2 mb-4">
                                <div style={{
                                    border: '1.5px solid #e8e8e8',
                                    borderRadius: '12px',
                                    // overflow: 'hidden',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                                }}>
                                    {/* Header row */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '1rem 1.25rem',
                                        borderBottom: showPhoneChange ? '1px solid #f0f0f0' : 'none',
                                        backgroundColor: '#fafafa'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                                            {/* <span style={{ fontSize: '1.1rem' }}>📱</span> */}
                                            <div>
                                                <h6 style={{ margin: 0, fontWeight: 700, fontSize: '0.95rem', color: '#1a1a1a' }}>Change Phone Number</h6>
                                                {!showPhoneChange && (
                                                    <p style={{ margin: 0, fontSize: '0.78rem', color: '#888' }}>
                                                        Current: {profileData?.data?.countryCode} {profileData?.data?.mobileNumber}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => { setShowPhoneChange(!showPhoneChange); setOtpSent(false); setNewPhone(''); setPhoneOtp(''); dispatch(clearChangePhone()); }}
                                            style={{
                                                backgroundColor: showPhoneChange ? '#f5f5f5' : '#89d6ce',
                                                color: showPhoneChange ? '#555' : '#fff',
                                                border: 'none',
                                                borderRadius: '8px',
                                                padding: '0.4rem 1.1rem',
                                                fontWeight: 600,
                                                fontSize: '0.85rem',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {showPhoneChange ? '✕ Cancel' : 'Change'}
                                        </button>
                                    </div>

                                    {/* Body — Step 1: enter new number */}
                                    {showPhoneChange && !otpSent && (
                                        <div style={{ padding: '1.25rem' }}>
                                            <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem', color: '#444', marginBottom: '0.6rem', display: 'block' }}>
                                                New Phone Number
                                            </Form.Label>

                                            {/* Phone row: flag picker + number input side by side */}
                                            <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'stretch', marginBottom: '1rem', position: 'relative', overflow: 'visible' }}>
                                                {/* Country picker — fixed width */}
                                                <div style={{ flexShrink: 0 }}>
                                                    <PhoneInput
                                                        countryCodeEditable={false}
                                                        enableSearch
                                                        disableSearchIcon={false}
                                                        defaultCountry="ES"
                                                        buttonStyle={{
                                                            width: '52px',
                                                            borderRadius: '8px 0 0 8px',
                                                            border: '1.5px solid #ddd',
                                                            borderRight: 'none',
                                                            backgroundColor: '#f8f8f8'
                                                        }}
                                                        inputStyle={{
                                                            width: '110px',
                                                            height: '44px',
                                                            borderRadius: '0 8px 8px 0',
                                                            border: '1.5px solid #ddd',
                                                            borderLeft: 'none',
                                                            fontSize: '0.9rem',
                                                            // paddingLeft: '2rem',
                                                            color: '#555',
                                                            backgroundColor: '#f8f8f8',
                                                            cursor: 'default',
                                                            marginLeft: '0.5rem'
                                                        }}
                                                        dropdownStyle={{ width: '280px', maxHeight: '200px' }}
                                                        value={newPhoneCountry}
                                                        onChange={(val) => setNewPhoneCountry(val)}
                                                        inputProps={{ readOnly: true }}
                                                    />
                                                </div>
                                                {/* Number input — takes remaining space */}
                                                <input
                                                    type="tel"
                                                    placeholder="Enter new number"
                                                    value={newPhone}
                                                    onChange={(e) => setNewPhone(e.target.value.replace(/\D/g, ''))}
                                                    style={{
                                                        flex: 1,
                                                        height: '44px',
                                                        border: '1.5px solid #ddd',
                                                        borderRadius: '8px',
                                                        padding: '0 0.9rem',
                                                        fontSize: '0.95rem',
                                                        outline: 'none',
                                                        transition: 'border-color 0.2s',
                                                        minWidth: 0
                                                    }}
                                                    onFocus={(e) => e.target.style.borderColor = '#89d6ce'}
                                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                                />
                                            </div>

                                            <button
                                                type="button"
                                                onClick={handleSendPhoneOtp}
                                                disabled={changePhoneData.loading}
                                                style={{
                                                    backgroundColor: '#89d6ce',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    padding: '0.55rem 1.5rem',
                                                    fontWeight: 600,
                                                    fontSize: '0.9rem',
                                                    cursor: changePhoneData.loading ? 'not-allowed' : 'pointer',
                                                    opacity: changePhoneData.loading ? 0.75 : 1,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}
                                            >
                                                {changePhoneData.loading
                                                    ? <><ClipLoader size={14} color="#fff" /> Sending…</>
                                                    : 'Send OTP'}
                                            </button>
                                        </div>
                                    )}

                                    {/* Body — Step 2: enter OTP */}
                                    {showPhoneChange && otpSent && (
                                        <div style={{ padding: '1.25rem' }}>
                                            {/* Sent-to pill */}
                                            <div style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.4rem',
                                                backgroundColor: '#e8f9f4',
                                                border: '1px solid #b2e8d8',
                                                borderRadius: '20px',
                                                padding: '0.3rem 0.9rem',
                                                fontSize: '0.82rem',
                                                color: '#1a7f4b',
                                                marginBottom: '1rem'
                                            }}>
                                                ✅ OTP sent to <strong>+{newPhoneCountry} {newPhone}</strong>
                                            </div>

                                            <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem', color: '#444', marginBottom: '0.5rem', display: 'block' }}>
                                                Enter the 6-digit OTP
                                            </Form.Label>

                                            <input
                                                type="tel"
                                                placeholder="- - - - - -"
                                                maxLength={6}
                                                value={phoneOtp}
                                                onChange={(e) => setPhoneOtp(e.target.value.replace(/\D/g, ''))}
                                                style={{
                                                    display: 'block',
                                                    width: '100%',
                                                    maxWidth: '200px',
                                                    height: '50px',
                                                    border: '1.5px solid #ddd',
                                                    borderRadius: '10px',
                                                    padding: '0 1rem',
                                                    fontSize: '1.4rem',
                                                    letterSpacing: '0.4rem',
                                                    textAlign: 'center',
                                                    outline: 'none',
                                                    marginBottom: '1rem',
                                                    fontWeight: 700,
                                                    color: '#1a1a1a'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#89d6ce'}
                                                onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                            />

                                            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                                <button
                                                    type="button"
                                                    onClick={handleVerifyPhoneOtp}
                                                    disabled={changePhoneData.loading}
                                                    style={{
                                                        backgroundColor: '#89d6ce',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '8px',
                                                        padding: '0.55rem 1.5rem',
                                                        fontWeight: 600,
                                                        fontSize: '0.9rem',
                                                        cursor: changePhoneData.loading ? 'not-allowed' : 'pointer',
                                                        opacity: changePhoneData.loading ? 0.75 : 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.4rem'
                                                    }}
                                                >
                                                    {changePhoneData.loading
                                                        ? <><ClipLoader size={14} color="#fff" /> Verifying…</>
                                                        : '✔ Verify & Update'}
                                                </button>

                                                <button
                                                    type="button"
                                                    onClick={handleSendPhoneOtp}
                                                    disabled={changePhoneData.loading}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#89d6ce',
                                                        border: '1.5px solid #89d6ce',
                                                        borderRadius: '8px',
                                                        padding: '0.5rem 1.1rem',
                                                        fontWeight: 600,
                                                        fontSize: '0.85rem',
                                                        cursor: changePhoneData.loading ? 'not-allowed' : 'pointer'
                                                    }}
                                                >
                                                    Resend OTP
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>


                            <div className="col-md-4">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>Cover Letter (PDF)</Form.Label>
                                    <div className="input-group mb-3">
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            disabled={!disabled}
                                            onChange={(e) => handlePdfUpload(e, 'coverLetter')}
                                            className="form-control"
                                        />

                                    </div>
                                    {coverLetter && (
                                        <a href={coverLetter} target="_blank" rel="noopener noreferrer" style={{ color: "#89d6ce", fontWeight: 600 }}>
                                            📄 View Uploaded Cover Letter
                                        </a>
                                    )}
                                </form>
                            </div>

                            <div className="col-md-4">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>CV (PDF)</Form.Label>
                                    <div className="input-group mb-3">
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            disabled={!disabled}
                                            onChange={(e) => handlePdfUpload(e, 'cv')}
                                            className="form-control"
                                        />
                                    </div>
                                    {cv && (
                                        <a href={cv} target="_blank" rel="noopener noreferrer" style={{ color: "#89d6ce", fontWeight: 600 }}>
                                            📄 View Uploaded CV
                                        </a>
                                    )}
                                </form>
                            </div>


                            <div className="col-md-4">
                                <form className="w-100 mb-4" appearance="outline">
                                    <Form.Label>ID Proof (PDF)</Form.Label>
                                    <div className="input-group mb-3">
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            disabled={!disabled}
                                            onChange={(e) => handlePdfUpload(e, 'idProof')}
                                            className="form-control"
                                        />
                                    </div>
                                    {idProof && (
                                        <a href={idProof} target="_blank" rel="noopener noreferrer" style={{ color: "#89d6ce", fontWeight: 600 }}>
                                            📄 View Uploaded ID
                                        </a>
                                    )}
                                </form>
                            </div>


                        </div >
                    }
                </div >

                <Modal show={showMap} onHide={() => setShowMap(false)} className="add_detalis">
                    <Modal.Header closeButton>
                        <Modal.Title>Select Address</Modal.Title>
                    </Modal.Header>

                    <div style={{ paddingBottom: 20 }}>
                        {error && <p>Error: {error}</p>}

                        {latitude && longitude && (
                            <PlaceSearch
                                lat={latitude}
                                lng={longitude}
                                setAddress={setAddress}
                                setLatitude={setLatitude}
                                setLongitude={setLongitude}
                                setEditedApt={setEditedApt}
                                setEditedHouse={setEditedHouse}
                                setEditedStreet={setEditedStreet}
                            />
                        )}

                        <div style={{ textAlign: "center" }}>
                            <Button onClick={() => setShowMap(false)}>OK</Button>
                        </div>
                    </div>
                </Modal>
            </div >
        </>
    )
}

export default NeditProfile
